import styled from 'styled-components';
import { InputStyled } from '../InputStyled';
import { rem } from 'polished';

export const InputStyledDS = styled(InputStyled)`
    span {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    input {
        width: 100%;
        border: 1px solid ${({ theme }) => theme.colors.black1};
        font-size: ${({ theme }) => theme.fontSizes.h5};
        border-radius: ${rem(4)};

        &.error {
            border-color: ${({ theme }) => theme.colors.danger};
        }
    }

    .currency {
        background: ${({ theme }) => theme.colors.black1};
        border-top-left-radius: ${rem(3)};
        border-bottom-left-radius: ${rem(3)};
        color: ${({ theme }) => theme.colors.white};
    }

    .inputToolTip {
        svg {
            g {
                circle {
                    stroke: ${({ theme }) => theme.colors.black} !important;
                }
                line {
                    stroke: ${({ theme }) => theme.colors.black} !important;
                }
            }
        }
    }
`;
